/**
 * 激活码兑换
 */
export const exchange = '/activationCode/exchange';